import { Box, Button, Heading, Image, Stack, Text, useToast } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Logo from '../assets/Logo_1.png'
import { motion } from 'framer-motion'
import { formatCPF } from '../utils/util'
import api from '../utils/api'

const MotionBox = motion(Box);

const PrintEtiqueta: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const enableInactivityRedirect = true; // altere para false para desativar

  // Dados do usuário vindos do state ou valores padrão
  const { nome, telefone, email, cpf, loja } = location.state || {
    nome: 'NÃO IDENTIFICADO',
    telefone: '00000000000',
    email: '--',
    cpf: '00000000000',
    loja: '--',
  };

  const handlePrint = () => {
    const handleCheckin = async () => {
      try {
        const response = await api.post('/checkin', {
          registration: location.state?.registrationUid, // UID da inscrição do usuário
          room: null, // Se houver uma sala associada, pode ser passada aqui
        });
        navigate('/autoatendimento');

        console.log("Check-in realizado:", response.data);
      } catch (error) {
        console.error("Erro ao realizar check-in:", error);
        toast({
          render: () => (
            <Box
              color="white"
              p={6}
              bg="red.500"
              fontSize="4xl"
              borderRadius="md"
              textAlign="center"
              borderWidth="2px"
              borderColor="white"
            >
              Erro ao registrar o check-in. Tente novamente.
            </Box>
          ),
          duration: 3000,
          isClosable: true,
        });
      }
    };

    // Adiciona o evento de callback após a impressão
    const afterPrintListener = () => {
      handleCheckin(); // Realiza o check-in apenas se a impressão foi bem-sucedida
      window.removeEventListener('afterprint', afterPrintListener);
    };

    window.addEventListener('afterprint', afterPrintListener);
    window.print();
  };

  const handleNovaCredencial = () => {
    navigate('/autoatendimento');
  };

  // Timer de inatividade: redireciona para "/autoatendimento" após 2 minutos sem interação
  useEffect(() => {
    if (!enableInactivityRedirect) return;
    let timeoutId = setTimeout(() => {
      navigate('/autoatendimento');
    }, 120000); // 2 minutos

    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        navigate('/autoatendimento');
      }, 120000);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('touchstart', resetTimer);
    window.addEventListener('keydown', resetTimer);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('touchstart', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [navigate, enableInactivityRedirect]);

  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      w="100vw"
      h="100vh"
      bg="#521577"
      color="white"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      overflow="hidden"
      px={6}
      py={6}
    >
      {/* Conteúdo superior alinhado ao topo */}
      <Box 
        width="85%" 
        mt="100px"
        display="flex" 
        flexDirection="column" 
        alignItems="center"
      >
        {/* Logo */}
        <Image src={Logo} alt="Logo" width="60%" mb={10} />
        
        {/* Espaço extra entre a logo e o Heading */}
        <Heading fontSize="6xl" fontWeight="bold" mb={6} mt={20}>
          IMPRIMIR ETIQUETA
        </Heading>
        
        {/* Bloco com os dados do usuário */}
        <Box
          bg="gray.100"
          color="gray.800"
          px={8}
          py={6}
          borderRadius="xl"
          width="85%"
          boxShadow="lg"
          mb={6}
          mt={4}
        >
          <Stack spacing={4}>
            <Text fontSize="3xl">
              <strong>Nome:</strong> {nome}
            </Text>
            <Text fontSize="3xl">
              <strong>CPF:</strong> {formatCPF(cpf)}
            </Text>
            <Text fontSize="3xl">
              <strong>Loja:</strong> {loja}
            </Text>
          </Stack>
        </Box>
        
        {/* Botão "Imprimir Credencial" com cor diferenciada */}
        <Button
          // bg="yellow.400"
          bg="gray.700"
          color="#ed4f2c"
          fontSize="5xl"
          fontWeight="bold"
          width="85%"
          height="100px"
          borderRadius="xl"
          _hover={{ bg: "blue.500" }}
          _active={{ transform: "scale(0.95)" }}
          mb={6}
          mt={4}
          onClick={handlePrint}
        >
          Imprimir Credencial
        </Button>
      </Box>
      
      {/* Botão "Nova Credencial" fixado na parte inferior */}
      <Button
        bg="rgba(45,55,72,0.6)" // Fundo semi-transparente (equivalente a gray.700 com 60% de opacidade)
        color="#ed4f2c"
        fontSize="4xl"
        fontWeight="bold"
        width="35%"
        height="120px"
        borderRadius="100px"
        _hover={{ bg: "rgba(45,55,72,0.8)" }} // Aumenta a opacidade no hover
        _active={{ transform: "scale(0.95)" }}
        onClick={handleNovaCredencial}
        mb={12}
      >
        Nova Credencial
      </Button>
    </MotionBox>
  );
};

export default PrintEtiqueta;
